import styled from 'styled-components'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.g100};
    max-width: 370px;
    margin: 0 auto;
    height: 100%;
`

export const BackgroundImageWrapper = styled.div`
    height: 180px;
    position: relative;
    overflow: hidden;

    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        /*! @noflip */
        background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 45%);
        opacity: 0.9;
        top: 0;
        left: 0;
    }
`

export const Year = styled.span`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.displayXL};
    ${(props) => props.theme.fontWeight.bold};
    position: absolute;
    bottom: 0;
    right: 20px;
    z-index: 1;
`

export const StoryBox = styled.div`
    padding: 30px;
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.displayS};
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.g600};
    margin-bottom: 20px;
`

export const Description = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
    text-align: justify;
`
